import React from 'react';
import filterBasicBreather from 'assets/images/filter-basic-breather.jpg';
import filterBasicBreatherWebp from 'assets/images/filter-basic-breather.jpg?as=webp';
import LazyLoad from 'react-lazyload';
import { useSelector } from 'react-redux';
import loadable from '@loadable/component';
import { SUPPORTED_REGIONS } from '../../../shared/enums';
import { getPerfectSquare } from '../../../shared/utils';
import { selectLocalizationData } from '../../features/localization/localizationSlice';

const FadeIn = loadable(() => import('../common/FadeIn'));

/**
 * @returns {JSX.Element}
 * @constructor
 */
const ColumnContent = () => {
  const localization = useSelector(selectLocalizationData);
  const measure = [ SUPPORTED_REGIONS.US, SUPPORTED_REGIONS.CA ].includes(localization.region) ? 'ft' : 'm';
  return (
    <section className='column-content'>
      <div className='container'>
        <div className='column-content__header'>
          <h2 className='column-content__header-title'>
            Mila packs
            {' '}
            {getPerfectSquare(45, localization.region, measure)}
            {' '}
            {measure}
            <sup>2</sup>
            {' '}
            of certified HEPA, the gold standard in
            ultrafine particle filtration.
          </h2>
        </div>
        <div className='column-content__body'>
          <figure className='column-content__image'>
            <LazyLoad>
              <FadeIn>
                <picture>
                  <source srcSet={filterBasicBreatherWebp} type='image/webp' />
                  <source srcSet={filterBasicBreather} type='image/jpg' />
                  <img src={filterBasicBreather} alt='filter-basic-breather' />
                </picture>
              </FadeIn>
            </LazyLoad>
          </figure>
          <div className='column-content__block'>
            <h3 className='column-content__title'>
              A lot of companies try to confuse you with big words: HEPA-type,
              HEPA-like, HEPA-grade, 99%-HEPA, patented nanotech, ionizes,
              neutralizes, destroys, vaporizes, etc.
              {' '}
            </h3>
            <div className='column-content__tip'>
              <p>(Pro Tip: this is all b.s. made up by some marketing guy named Bob.)</p>
            </div>
            <div className='column-content__description'>
              <p>
                HEPA is the ONLY filtration technology repeatedly proven to
                filter out 99.97% of airborne particles 0.3
                micrometers (µm) in diameter, such as smoke, allergens,
                house dust, PM2.5, and PM10.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ColumnContent;
